var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7633_78668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25434 2.04013L8.24571 1.37582H7.5814C7.53499 1.37538 7.48858 1.37538 7.44218 1.37582C3.41752 1.41425 0.186023 4.70807 0.22446 8.73272C0.262898 12.7574 3.55671 15.9889 7.58137 15.9504C11.6041 15.946 14.8642 12.6862 14.869 8.66347V7.99916H8.24571L8.25434 2.04013Z",
    fill: "#1B2A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58691 0.0493164V6.67197H16.2089C16.1918 3.02175 13.2371 0.0667852 9.58691 0.0493164Z",
    fill: "#1B2A3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7633_78668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.b6df288ec34cffacb133f0481157a1a0.svg";
export { ForwardRef as ReactComponent };